import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  focusedParagraphId: null,
  deletedParagraphIds: [],
  editedParagraphIds: [],
  completedParagraphIds: [],
  editedParagraphCurrentTexts: {},
  isDirty: false,
  issueIdsFilter: [],
};

export const editAnalysisSlice = createSlice({
  name: "edit",
  initialState: INITIAL_STATE,
  reducers: {
    resetEditing: () => INITIAL_STATE,
    setFocusedParagraphId: (state, { payload }) => {
      state.focusedParagraphId = payload ?? null;
    },
    setDeletedParagraphIds: (state, { payload }) => {
      state.deletedParagraphIds = payload ?? [];
    },
    setEditedParagraphIds: (state, { payload }) => {
      state.editedParagraphIds = payload ?? [];
    },
    setCompletedParagraphIds: (state, { payload }) => {
      state.completedParagraphIds = payload ?? [];
    },
    setEditedParagraphCurrentTexts: (state, { payload }) => {
      state.editedParagraphCurrentTexts = payload ?? {};
    },
    toggleIssueIdsFilter: (state, { payload: issueId }) => {
      const { issueIdsFilter } = state;
      const index = issueIdsFilter.indexOf(issueId);

      if (index > -1) {
        issueIdsFilter.splice(index, 1);
        state.issueIdsFilter = issueIdsFilter;
      } else {
        state.issueIdsFilter = issueIdsFilter.concat(issueId);
      }
    },
    setIssueIdsFilter: (state, { payload }) => {
      state.issueIdsFilter = Array.isArray(payload) ? payload : [];
    },
  },
});

export const {
  resetEditing,
  setFocusedParagraphId,
  setDeletedParagraphIds,
  setEditedParagraphIds,
  setCompletedParagraphIds,
  setEditedParagraphCurrentTexts,
  toggleIssueIdsFilter,
  setIssueIdsFilter,
} = editAnalysisSlice.actions;

export default editAnalysisSlice.reducer;
